import { render, staticRenderFns } from "./ProfileSidebar.vue?vue&type=template&id=7a8534f1&scoped=true&"
import script from "./ProfileSidebar.vue?vue&type=script&lang=js&"
export * from "./ProfileSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ProfileSidebar.vue?vue&type=style&index=0&id=7a8534f1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8534f1",
  null
  
)

export default component.exports